import globalEn from './en/global.json';
import storesEn from './en/stores.json';
import workOrdersTableEn from './en/workOrdersTable.json';
import workOrderStepperEn from './en/workOrderStepper.json';
import globalEs from './es/global.json';
import storesEs from './es/stores.json';
import workOrdersTableEs from './es/workOrdersTable.json';
import workOrderStepperEs from './es/workOrderStepper.json';
const lang = {
  en: {
    global: globalEn,
    workOrdersTable: workOrdersTableEn,
    workOrderStepper: workOrderStepperEn,
    stores: storesEn,
  },
  es: {
    global: globalEs,
    workOrdersTable: workOrdersTableEs,
    workOrderStepper: workOrderStepperEs,
    stores: storesEs,
  },
};

export default lang;
